import * as tslib_1 from "tslib";
import { EventEmitter } from "@angular/core";
import { BaseComponent } from "../../base/base.component";
import { AppComponent } from "../../app.component";
import { Router } from "@angular/router";
import { PhotosphereManager } from "../../../business/managers/photosphere.manager";
import { ProductModel } from "../../../datastore/entities/product.model";
import { Location } from "@angular/common";
import { AlertUtils } from "../../../crossconcern/utilities/utils/alert.utils";
var ProductlinkComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ProductlinkComponent, _super);
    function ProductlinkComponent(appComponent, router, photosphereManager, location, alertUtils) {
        var _this = _super.call(this, appComponent, router, alertUtils, location) || this;
        _this.appComponent = appComponent;
        _this.router = router;
        _this.photosphereManager = photosphereManager;
        _this.location = location;
        _this.alertUtils = alertUtils;
        _this.productLinkDelete = new EventEmitter();
        _this.productLinkClose = new EventEmitter();
        _this.productLinkSave = new EventEmitter();
        return _this;
    }
    ProductlinkComponent.prototype.ngOnInit = function () {
        if (this.editedProductLink) {
            this.selectedItems = [
                this.editedProductLink
            ];
        }
        this.dropdownSettings = {
            singleSelection: true,
            idField: "uuid",
            textField: "name",
            enableCheckAll: false,
            allowSearchFilter: true
        };
    };
    ProductlinkComponent.prototype.onProductLinkDelete = function () {
        this.productLinkDelete.emit();
    };
    ProductlinkComponent.prototype.onProductLinkSave = function () {
        this.productLinkSave.emit({
            product: this.selectedItems[0]
        });
        this.selectedItems = [];
    };
    ProductlinkComponent.prototype.onCloseClick = function () {
        this.productLinkClose.emit();
    };
    ProductlinkComponent.prototype.onItemSelect = function (_) {
        // empty
    };
    return ProductlinkComponent;
}(BaseComponent));
export { ProductlinkComponent };
